import { render, staticRenderFns } from "./PopOrders.vue?vue&type=template&id=08797e91&"
import script from "./PopOrders.vue?vue&type=script&lang=js&"
export * from "./PopOrders.vue?vue&type=script&lang=js&"
import style0 from "./PopOrders.vue?vue&type=style&index=0&id=08797e91&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports